<template>
  <div
    class="text-static-white flex w-fit min-w-fit items-center gap-1 whitespace-nowrap rounded-xl px-2 py-1 text-xs font-medium"
    :class="[label.variant, { 'pl-1': label.icon }]"
    :style="{ color: label.textColor, backgroundColor: label.backgroundColor }"
  >
    <img
      v-if="label.icon"
      :src="iconSrc"
      width="16"
      height="16"
      role="presentation"
      alt=""
    />
    <slot />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import type { Label } from './types';

  const props = defineProps<{
    label: Label;
  }>();

  const iconSrc = computed(() => {
    return new URL(
      `/src/assets/images/feature/${props.label.icon}.svg`,
      import.meta.url,
    ).href;
  });
</script>

<style scoped>
  .blue {
    @apply bg-background-info-primary;
  }
  .green {
    @apply bg-background-positive-primary;
  }
  .red {
    @apply bg-background-negative-primary;
  }
  .orange {
    @apply bg-background-warning-accent;
  }
  .skyblue {
    @apply bg-background-info-secondary;
  }
</style>
